import { render, staticRenderFns } from "./EinstellungenJournal.vue?vue&type=template&id=b0a3fd4e"
import script from "./EinstellungenJournal.vue?vue&type=script&lang=js"
export * from "./EinstellungenJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports